import React from "react";
import { Button } from '@progress/kendo-react-buttons';
import './AddEditClient.Header.scss';
import { useHistory } from "react-router-dom";

export type AddEditClientHeaderProps = {
  onSubmit: () => void;
  onCancel: () => void;
};

const AddEditClientHeader: React.FC<AddEditClientHeaderProps> = ({
  onSubmit, onCancel
}) => {
  const [submitting, setSubmitting] = React.useState(false);

  const handleSubmit = React.useCallback(() => {
    if (submitting) return;
    setSubmitting(true);
    Promise.resolve(onSubmit()).finally(() => setSubmitting(false));
  }, [onSubmit, submitting]);

  return (
    <div className="client-header">
      <h1>New Client</h1>
      <Button 
        primary 
        look="outline" 
        className="ml-auto"
        onClick={onCancel}
        disabled={submitting}
      >
        Cancel
      </Button>
      <Button 
        primary 
        style={{ marginLeft: 20 }}
        onClick={handleSubmit}
        disabled={submitting}
      >
        Save Changes
      </Button>
    </div>
  );
}

export default AddEditClientHeader;